import { ResultCategories } from '../../results/Results';

export const calculateScoresFromCheckInAnswers = (answers) => {
  let scores = {
    [ResultCategories.PAIN]: 0,
    [ResultCategories.WORRY]: 0,
    [ResultCategories.MOOD]: 0,
    [ResultCategories.SLEEP]: 0,
    [ResultCategories.SUBSTANCE]: undefined,
  };
  for (let groupLinkId in answers) {
    let score = 0;
    for (let linkId in answers[groupLinkId]) {
      if (linkId !== 'PI_0') {
        score += answers[groupLinkId][linkId].valueDecimal;
      }
    }
    if (groupLinkId === 'BSCQ') {
      score /= Object.keys(answers[groupLinkId]).length;
    }
    switch (groupLinkId) {
      case 'PI':
        scores.pain = score * 5;
        break;
      case 'AQ':
        scores.worry = score * 5;
        break;
      case 'DS':
        scores.mood = score * 5;
        break;
      case 'SQ':
        scores.sleep = Math.min(Math.ceil(score * 2.86), 100);
        break;
      case 'CQ':
        if (score === 0) {
          scores.substance = -1;
        }
        break;
      case 'BSCQ':
        scores.substance = Math.min(101 - Math.ceil(score), 100);
        break;
      default:
        break;
    }
  }
  return scores;
};
